import { TableColumnInterface } from '../interfaces/table-column.interface';

export const TREATMENTS_TABLE_COLUMNS: TableColumnInterface[] = [
  {
    name: 'prestador',
    displayName: 'Prestador'
  },
  {
    name: 'data',
    displayName: 'Data'
  },
  {
    name: 'valorFranquia',
    displayName: 'Valor da Franquia'
  }
];
